import { useMutation } from '@tanstack/react-query';

import { handleError, handleSuccess } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { postDownloadApplicationDocs } from '../../requests/postDownloadApplicationDocs';

export const useDownloadApplicationDocs = () => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync: downloadApplicationDocs, ...rest } = useMutation({
    mutationFn: ({
      uuid,
      definitionName,
    }: {
      uuid: string;
      definitionName: string;
    }) =>
      postDownloadApplicationDocs(constructPost, uuid, definitionName).then(
        (response) => response?.data,
      ),
    onError: () => handleError('Failed to download documents'),
    onSuccess: () =>
      handleSuccess(
        'Collecting files - you will receive all documents via email',
      ),
  });

  return { downloadApplicationDocs, ...rest };
};
